import { Sparkles, Play } from 'lucide-react';
import { Button } from '../ui/Button';

export const Hero = () => {
  return (
    <section className="relative pt-40 pb-24 overflow-hidden hero-pattern">
      <div className="max-w-7xl mx-auto px-6 flex flex-col md:flex-row items-center gap-16">
        
        <div className="flex-1 space-y-8 text-center md:text-left">
          <div className="inline-flex items-center gap-2 bg-[#D4AF37]/10 text-[#B8860B] px-4 py-1 rounded-full text-xs font-bold tracking-wider uppercase">
            <Sparkles size={16} /> Inteligência Artificial Generativa
          </div>
          
          <h1 className="text-5xl md:text-7xl font-extrabold tracking-tight leading-tight">
            Transforme suas <span className="text-transparent bg-clip-text gold-gradient">memórias</span> em música.
          </h1>
          
          <p className="text-xl text-slate-600 leading-relaxed max-w-2xl">
            Nossa IA converte seus relatos, fatos marcantes e sentimentos em composições musicais exclusivas e vídeos emocionantes. O presente perfeito para quem você ama.
          </p>
          
          <div className="flex flex-col sm:flex-row items-center gap-4 justify-center md:justify-start">
            <Button className="w-full sm:w-auto px-10 py-5 text-lg">
              Criar minha homenagem
            </Button>
            <Button variant="outline" className="w-full sm:w-auto px-10 py-5 text-lg">
              Ver exemplos
            </Button>
          </div>
        </div>
        
        <div className="flex-1 relative">
          <div className="relative z-10 w-full max-w-md mx-auto aspect-square bg-white rounded-3xl p-4 shadow-2xl rotate-3 hover:rotate-0 transition-transform duration-500">
            <img 
              src="https://images.unsplash.com/photo-1516280440614-37939bbacd81?auto=format&fit=crop&q=80&w=800" 
              alt="Capa de Álbum Personalizada" 
              className="w-full h-full object-cover rounded-2xl"
            />
            
            <div className="absolute -bottom-6 -left-6 bg-white p-4 rounded-2xl shadow-xl flex items-center gap-4 border border-slate-100">
              <div className="w-12 h-12 gold-gradient rounded-full flex items-center justify-center text-white">
                <Play size={20} className="fill-current" />
              </div>
              <div>
                <p className="text-xs font-bold text-slate-400 uppercase">Agora tocando</p>
                <p className="text-sm font-extrabold">Nossa História - MPB</p>
              </div>
            </div>
          </div>
          
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-80 h-80 bg-[#D4AF37]/20 blur-3xl rounded-full -z-10"></div>
        </div>

      </div>
    </section>
  );
};